<template>
  <div>
    <h2 class="text-2xl font-bold mb-8">General</h2>

    <FormulateForm
      name="general"
      @submit="submit"
      :key="`image-${currentCompany.id}`"
    >
      <FormulateInput
        v-model="name"
        type="text"
        name="name"
        label="Name"
        validation="required"
      />
      <FormulateInput
        v-model="short_name"
        type="text"
        name="short_name"
        label="Short name"
        validation="optional|between:-1,3,length"
        validation-name="Short name"
        :validation-messages="{
          between: 'Short name has to be 1-2 characters long.',
        }"
      />
      <FormulateInput
        type="image"
        name="image"
        label="Logo"
        help="Select a png, jpg or gif to upload."
        validation="mime:image/jpeg,image/png,image/gif"
        upload-behavior="delayed"
        :uploader="save"
        :value="image"
      />
      <FormulateErrors />

      <base-button type="submit" :loading="saving">
        Save
      </base-button>
    </FormulateForm>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  data() {
    return {
      saving: false,
      name: '',
      short_name: '',
    };
  },
  computed: {
    ...mapState('company', ['cacheBuster']),
    ...mapGetters('company', ['currentCompany']),
    image() {
      const { image } = this.currentCompany;
      return image
        ? [
            {
              url: `https://linkmanager-stage.datacroft.de${image}?cache=${this.cacheBuster}`,
            },
          ]
        : false;
    },
  },
  watch: {
    currentCompany() {
      this.updateFields();
    },
  },
  mounted() {
    this.updateFields();
  },
  methods: {
    updateFields() {
      this.name = this.currentCompany.name;
      this.short_name = this.currentCompany.short_name || '';
    },
    async save(file, progress) {
      try {
        this.saving = true;
        const company = new FormData();
        company.set('image', file);
        await this.$store.dispatch('company/updateCompany', {
          company,
          progress,
        });
      } catch (error) {
        this.$formulate.handle(error, 'general');
      } finally {
        this.saving = false;
      }
    },
    async submit() {
      try {
        this.saving = true;
        const company = new FormData();
        company.set('name', this.name);
        company.set('short_name', this.short_name);
        await this.$store.dispatch('company/updateCompany', {
          company,
        });
      } catch (error) {
        this.$formulate.handle(error, 'general');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
